import {
  AlertIcon,
  CompletedCheckmarkIcon,
  Typography,
} from "@commonsku/styles";
import _ from "lodash";
import React from "react";

interface ConnectedShopIndicatorProps {
  external_store_id: string | null;
  external_store_type: string | null;
  external_store_url: string | null;
  external_store_name: string | null;
}

const ConnectedShopIndicator = ({
  external_store_id,
  external_store_url,
  external_store_name,
  external_store_type,
}: ConnectedShopIndicatorProps) => {
  const storeNameAndType = (
    <>
      {external_store_name}{" "}
      {external_store_type
        ? `in ${_.startCase(_.lowerCase(external_store_type))}`
        : ""}
    </>
  );
  return external_store_id ? (
    <>
      <CompletedCheckmarkIcon
        color="black"
        style={{ marginRight: 12 }}
        size="medium"
      />
      <Typography.Text
        fontSize={"16px"}
        style={{ marginBottom: 0, lineHeight: 0 }}
      >
        This shop is connected to
      </Typography.Text>
      &nbsp;
      {external_store_url?.trim() ? (
        <a
          href={
            /^https?:\/\//.test(external_store_url)
              ? external_store_url
              : `https://${external_store_url}`
          }
          target="_blank"
          rel="noreferrer noopener"
          style={{ fontWeight: "bold" }}
        >
          {storeNameAndType}
        </a>
      ) : (
        <span style={{ fontWeight: "bold" }}>{storeNameAndType}</span>
      )}
    </>
  ) : (
    <>
      <AlertIcon style={{ marginRight: 12 }} size="medium" />
      <Typography.Text
        fontSize={"16px"}
        style={{ marginBottom: 0, lineHeight: 0 }}
      >
        This shop is not connected to any external store.
      </Typography.Text>
      &nbsp;
      <a
        href={"https://help.commonsku.com/knowledge/integrations#shops"}
        target="_blank"
        rel="noreferrer noopener"
        style={{ fontWeight: "bold" }}
      >
        Learn how to connect
      </a>
    </>
  );
};

export default ConnectedShopIndicator;
